import React, { useState } from 'react';
import StudySectionIcon from './StudySectionIcon';
import { Box, Stack, Typography } from '@mui/material';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import FitbitCollectionDataView from './FitbitCollectionDataView';
import ExportFormSection from './collection/ExportFormSection';
import StudyBucketButton from './StudyBucketButton';
import OutdatedStudyNotice from '../common/OutdatedStudyNotice';
import StudyExportFolders, { DailyExtractionSetupButton } from './StudyExportFolders';
import { researcherPageSx, researcherContentSx, researcherTitleSx } from './researcherPresentation';
import { CollectionSourceProvider } from '../../contexts/CollectionSourceContext';
import { CollectionSourceId, collectionSources } from '../../config/collectionSources';
import CollectionSourcePicker from './collection/CollectionSourcePicker';

export default function StudyDataExport({ studyId, legacy, outdated = false, source: controlledSource, onSourceChange }: {
  studyId: string; legacy: React.ReactElement<{ source?: 'fitbit' | 'healthkit' }>;
  outdated?: boolean;
  source?: CollectionSourceId; onSourceChange?: (source: CollectionSourceId) => void;
}) {
  const [localSource, setLocalSource] = useState<CollectionSourceId>('fitbit');
  const source = controlledSource || localSource;
  const setSource = onSourceChange || setLocalSource;
  return <CollectionSourceProvider source={source} key={source}><Box component="section" aria-label="Data export" sx={researcherPageSx}>
    <Box sx={researcherContentSx}>
      <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'stretch', md: 'center' }} justifyContent="space-between" gap={1.25} sx={{ mb: 1.5 }}>
        <Stack direction="row" gap={1} alignItems="center">
          <StudySectionIcon><FileDownloadOutlined /></StudySectionIcon>
          <Typography component="h1" sx={researcherTitleSx}>Data extraction</Typography>
        </Stack>
        <Stack direction="row" flexWrap="wrap" useFlexGap gap={1} alignItems="center" justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}>
          <StudyExportFolders />
          <StudyBucketButton studyId={studyId} />
        </Stack>
      </Stack>
      <ExportFormSection step={1} title="Data source" inline>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between">
          <CollectionSourcePicker value={source} onChange={setSource} />
          {collectionSources[source].supportsDaily && !(source === 'fitbit' && outdated) && <DailyExtractionSetupButton studyId={studyId} />}
        </Stack>
      </ExportFormSection>
      {source === 'fitbit' && outdated ? <OutdatedStudyNotice expanded /> : source !== 'healthkit' ? <FitbitCollectionDataView mode="export" studyId={studyId}
        legacy={source === 'fitbit' ? React.cloneElement(legacy, { source: 'fitbit' }) : undefined} /> : React.cloneElement(legacy, { source: 'healthkit' })}
    </Box>
  </Box></CollectionSourceProvider>;
}
